import type { DtrumApi } from "@dynatrace/dtrum-api-types/dtrum";

import { getLogger } from "@expert/logging";

const logger = getLogger({ module: "RealUserMonitoringClient" });

function getDtrum(): DtrumApi | undefined {
    if (import.meta.env.VITE_DYNATRACE_ENABLED !== "true") return undefined;
    return window.dtrum;
}

export function enableDynatraceSessionReplay() {
    const dtrum = getDtrum();
    if (!dtrum) return;
    try {
        dtrum.enableSessionReplay(true);
    } catch (error) {
        logger.debug({ error }, "Failed to enable Dynatrace session replay");
    }
}

export function identifyDynatraceUser(userId: string) {
    const dtrum = getDtrum();
    if (!dtrum) return;
    try {
        dtrum.identifyUser(userId);
    } catch (error) {
        logger.debug({ error }, "Failed to identify Dynatrace user");
    }
}

import type { ChannelKind } from "@/sdk/agent/types";

type JourneyType = "Login" | "Callback" | "OutboundCall" | "SaleEnrollment" | `Incoming${ChannelKind}`;

const activeActions = new Map<string, number>();

function getActionKey(journey: JourneyType, taskId?: string) {
    return taskId ? `${journey}:${taskId}` : journey;
}

export function startDynatraceAction(journey: JourneyType, taskId?: string) {
    const dtrum = getDtrum();
    if (!dtrum) return;
    try {
        const actionId = dtrum.enterAction(journey);
        activeActions.set(getActionKey(journey, taskId), actionId);
    } catch (error) {
        logger.debug({ error, journey }, "Failed to start Dynatrace action");
    }
}

export function endDynatraceAction(journey: JourneyType, { taskId, error }: { taskId?: string; error?: string } = {}) {
    const dtrum = getDtrum();
    if (!dtrum) return;
    const key = getActionKey(journey, taskId);
    try {
        const actionId = activeActions.get(key);
        if (actionId) {
            if (error) {
                dtrum.reportError(error, actionId);
            }
            dtrum.leaveAction(actionId);
            activeActions.delete(key);
        }
    } catch (err) {
        logger.debug({ error: err, journey }, "Failed to end Dynatrace action");
    }
}
